/**
 * EditAiHintsCtrl controller
 * Promoted Search Suggestions (AI hints) section
 */

const dragndropImg = new window.Image()
dragndropImg.src = require('../../img/dragndrop.png')

/* @ngInject */

export default function EditAiHintsCtrl ($http, $timeout, $document, $scope, $state, pckg, hints, scope) {
  const vm = this
  vm.pckg = pckg
  vm.hints = hints || []

  const sharedScope = scope || ($state.$current && $state.$current.locals && $state.$current.locals.scope)
  if (sharedScope) {
    sharedScope.aiHintsCtrl = vm
  }

  vm.hasEditingHint = function () {
    return vm.hints.some(hint => hint.editing)
  }

  vm.updateSortOrder = function () {
    vm.hints.forEach((hint, idx) => {
      hint.sortOrder = idx + 1
    })
  }

  vm.addHint = function addHint () {
    if (vm.hints.length >= 5) return

    if (sharedScope) {
      sharedScope.updatedHints = true
    }

    const newHint = {
      hintValue: '',
      sortOrder: vm.hints.length + 1
    }

    vm.hints.push(newHint)

    $timeout(() => {
      const index = vm.hints.length - 1
      vm.startEdit(newHint, index)
    }, 0)
  }

  vm.startEdit = function (hint, index) {
    if (hint.editing) return
    event && event.stopPropagation()
    if (sharedScope) {
      sharedScope.updatedHints = true
    }

    hint.editingIndex = index
    hint.originalValue = hint.hintValue
    hint.editing = true
    $timeout(() => {
      const input = document.getElementById(`hint-input-${index}`)
      if (input) {
        input.focus()
        const length = input.value.length
        input.setSelectionRange(length, length)
      }
    }, 0)
  }

  vm.saveHint = function (hint, isBlur) {
    event && event.stopPropagation()

    $timeout(() => {
      if (!hint.editing) return

      if (!hint.hintValue || hint.hintValue.trim() === '') {
        const index = vm.hints.indexOf(hint)
        if (index > -1) {
          vm.hints.splice(index, 1)
          vm.updateSortOrder()
        }
        return
      }

      hint.editing = false
      if (!isBlur) {
        delete hint.originalValue
      }
      delete hint.editingIndex
    }, 250)
  }

  vm.cancelEdit = function (hint) {
    event && event.stopPropagation()

    hint.editing = false

    hint.hintValue = hint.originalValue
    delete hint.originalValue
    delete hint.editingIndex

    if (!hint.hintValue || hint.hintValue.trim() === '') {
      const index = vm.hints.indexOf(hint)
      if (index > -1) {
        vm.hints.splice(index, 1)
        vm.updateSortOrder()
      }
    }
  }

  vm.deleteHint = function (hint) {
    event && event.stopPropagation()

    if (sharedScope) {
      sharedScope.updatedHints = true
    }

    const index = vm.hints.indexOf(hint)
    if (index > -1) {
      vm.hints.splice(index, 1)
      vm.updateSortOrder()
    }
  }

  vm.getSelected = function (list, hint) {
    hint.selected = true
    return list.filter(hint => hint.selected)
  }

  vm.onDragstart = function (list, event) {
    list.dragging = true
    if (event.dataTransfer && event.dataTransfer.setDragImage) {
      event.dataTransfer.setDragImage(dragndropImg, 0, 0)
    }
  }

  vm.onDragend = function (list) {
    list.forEach(item => {
      item.selected = false
    })
    list.dragging = false
  }

  vm.onMoved = function (list) {
    for (let i = list.length - 1; i >= 0; i--) {
      if (list[i].selected) {
        list.splice(i, 1)
      }
    }
  }

  vm.onDrop = function (list, items, index) {
    if (sharedScope) {
      sharedScope.updatedHints = true
    }

    items.forEach(item => {
      item.selected = false
    })

    const newList = list
      .slice(0, index)
      .concat(items)
      .concat(list.slice(index))

    vm.hints.length = 0
    vm.hints.push(...newList.filter(item => !item.selected))

    vm.updateSortOrder()

    return true
  }
}
